<div class="power-limitation flex gap-[24px] flex-col">
  <div class="power-limitation__header flex flex-col">
    <div class="flex flex-row gap-[16px] justify-start items-end">
      <h2 class="mb-4">
        {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.OVERVIEW' | translate }}
      </h2>
    </div>
    <p>
      {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.INFORMATION' | translate }}
    </p>
  </div>
  <div class="power-limitation__container" *ngIf="filteredData.length && !isLoading; else noData">
    <div class="power-limitation__table">
      <div class="header-row flex flex-row">
        <div class="table-cell">
          {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.START_DATE' | translate }}
        </div>
        <div class="table-cell">
          {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.START_TIME' | translate }}
        </div>
        <div class="table-cell">
          {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.END_DATE' | translate }}
        </div>
        <div class="table-cell">
          {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.END_TIME' | translate }}
        </div>
        <div class="title flex-1">
          {{
            '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.CONTROLLABLE_DEVICE'
              | translate
          }}
        </div>
        <div class="title flex-1">
          {{
            '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.CONTROL_COMMAND' | translate
          }}
        </div>
        <div class="table-cell">
          {{
            '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.LIMITATION_VALUE' | translate
          }}
        </div>
      </div>
      <div class="flex flex-col">
        <div class="entry-row flex flex-row" *ngFor="let entry of filteredData">
          <div class="table-cell">{{ entry.startDate }}</div>
          <div class="table-cell">{{ entry.startTime }}</div>
          <div class="table-cell">{{ entry.endDate }}</div>
          <div class="table-cell">{{ entry.endTime }}</div>
          <div class="value flex-1">{{ entry.controllableDevice }}</div>
          <div class="value flex-1">
            {{
              customTranslationsService.POWER_LIMITATION_HISTORY_LOG[entry.controlCommand]
                | translate
            }}
          </div>
          <div class="table-cell">{{ entry.limitationValue }}</div>
        </div>
      </div>
    </div>
  </div>
  <vi-loader *ngIf="isLoading" [isLoading]="true"></vi-loader>

  <ng-template #noData>
    <div *ngIf="!isLoading" class="no-data">
      {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.NO_DATA' | translate }}
    </div>
  </ng-template>
</div>
